<ion-content class="ion-text-center modal">
  <rc-modal-header></rc-modal-header>
  <div class="ion-padding">
    <ion-text class="ion-text-center">{{ description }}</ion-text>
    <pinch-zoom class="border-radius container-outline">
      <cdn-img [src]="src" size="xl"></cdn-img>
    </pinch-zoom>
  </div>
</ion-content>
